/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import React, {useState} from 'react';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import Notifications from '@mui/icons-material/esm/Notifications';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { FormattedMessage } from 'react-intl';
import Tooltip from '@mui/material/Tooltip';

import * as Actions from '../../actions/actions';
import NotificationsDrawer from './NotificationsDrawer';

function NotificationsComponent(props) {
	const [anchorEl, setAnchorEl] = useState(null);

		return (
			<div>
				<Tooltip
					enterDelay={300}
					title={<FormattedMessage id="Tooltip.Notifications" defaultMessage="Notifications" />}
				>
					<div>
						<IconButton
							onClick={(event) => setAnchorEl(event.currentTarget)}
							disabled={props.notifications.notifications.length === 0}
							size="large"
						>
							<Badge
								badgeContent={props.notifications.notifications.length}
							>
								<Notifications
									sx={{
										color: (theme) =>
											`${theme.components.MuiAppBar.styleOverrides.colorIcon.backgroundColor}, ${
												props.notifications.notifications.length === 0 ? 0.3 : 1
											})`
									}}
								/>
							</Badge>
						</IconButton>
					</div>
				</Tooltip>
				<NotificationsDrawer anchorEl={anchorEl} close={() => setAnchorEl(null)}/>
				<NotificationContainer />
			</div>
		);
}

function mapStateToProps(state) {
	return {
		notifications: state.notifications,
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({ ...Actions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsComponent);
